import { ParentSavedPaymentMethodsPanel } from '~shared/components/parent-saved-payment-methods-panel';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '~shared/shadcn/ui/dialog';

export interface ManageParentSquarePaymentMethodsDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  parentId: string;
  parentEmail?: string | null;
}

/**
 * Dialog wrapper around the parent saved-payment-methods panel.
 * Prefer the dedicated page from family details; keep this for in-flow
 * surfaces (e.g. enrollment confirmation).
 */
export const ManageParentSquarePaymentMethodsDialog = ({
  open,
  onOpenChange,
  parentId,
  parentEmail,
}: ManageParentSquarePaymentMethodsDialogProps) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className='sm:max-w-[480px]'>
        <DialogHeader>
          <DialogTitle>Saved payment methods</DialogTitle>
          <DialogDescription>
            Payment methods on file
            {parentEmail ? (
              <>
                {' '}
                for{' '}
                <span className='font-medium text-foreground'>
                  {parentEmail}
                </span>
              </>
            ) : null}
          </DialogDescription>
        </DialogHeader>

        <ParentSavedPaymentMethodsPanel
          parentId={parentId}
          parentEmail={parentEmail}
          enabled={open}
        />
      </DialogContent>
    </Dialog>
  );
};
